export default __webpack_public_path__ + "static/media/cabinet1-after-768w.f7220c2c.webp";